import React from 'react'

import BkFlowRoomCardMediaGallery from '../elements/gallery/BkFlowRoomCardMediaGallery'
import BkFlowRoomCardDescriptionAccordion from '../elements/BkFlowRoomCardDescriptionAccordion'
import BkFlowFeaturedIcons from '../elements/icons/BkFlowRoomFeaturedIcons'
import BkFlowRoomCardRateStageCta from '../elements/multi-stage/BkFlowRoomCardRateStageCta'

import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'
import _ from 'lodash'
import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'multi-stage') {
	require('../../../styles/css/components/room/bk-flow-room-cards-multi-stage.css')
}

const BkFlowRoomCardMultiStage = props => {
	const {
		hotelLabels,
		hotelPhone,
		cards,
		displayedPriceFrequency,
		gallery,
		imageClickEvent,
		renderFullScreenButton,
		isFullScreen,
		isTaxInclusiveProperty,
		fullScreenEvent,
		quantityNotifications,
		unrefinedGuestRoom,
		unrefinedRoomDescription,
		roomDescriptionEvent,
		roomDescriptionExpanded,
		roomRateStageEvent,
		roomGroup,
		totalNights,
		activeCurrencyData,
		virtualTourEvent
	} = props

	let totalRoomRates = null,
			lowestRoomRate = null,
			currentCurrencyCode = 'USD',
			currentCurrencySymbol = getCurrencySymbol(currentCurrencyCode)

	if (
		cards &&
		cards.viewExtensions &&
		cards.viewExtensions.roomRates
	) {
		totalRoomRates = cards.viewExtensions.roomRates.length
		currentCurrencyCode = cards.viewExtensions.roomRates[0].rates[0].total.currencyCode
		currentCurrencySymbol = getCurrencySymbol(currentCurrencyCode)

		const roomRateData = []

		for (const rate in cards.viewExtensions.roomRates) {
			const currentRoomRate = cards.viewExtensions.roomRates[rate].rates[0]

			if (displayedPriceFrequency === 'per stay') {
				if (isTaxInclusiveProperty) {
					roomRateData.push(currentRoomRate.total.amountAfterTax)
				} else {
					roomRateData.push(currentRoomRate.total.amountBeforeTax)
				}
			} else {
				if (isTaxInclusiveProperty) {
					roomRateData.push(currentRoomRate.total.amountAfterTax / totalNights)
				} else {
					roomRateData.push(currentRoomRate.total.amountBeforeTax / totalNights)
				}
			}
		}

		lowestRoomRate = Math.min.apply(null, roomRateData)

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			lowestRoomRate = lowestRoomRate * activeCurrencyData.exchangeRate
			currentCurrencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				currentCurrencySymbol = activeCurrencyData.currencySymbol
			} else {
				currentCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}
	}

	return (
		<div
			id={ 'bk-flow-room__' + cards.roomTypeCode }
			key={ cards.roomTypeCode }
			className="bk-flow-room__card-entry u-remove-padding"
		>
			<BkFlowRoomCardMediaGallery
				cards={cards}
				enableBullets={ true }
				fullScreenEvent={fullScreenEvent}
				gallery={gallery}
				hotelLabels={hotelLabels}
				imageClickEvent={imageClickEvent}
				isFullScreen={isFullScreen}
				quantityNotifications={quantityNotifications}
				renderFullScreenButton={renderFullScreenButton}
				totalRoomRates={totalRoomRates}
				virtualTourEvent={virtualTourEvent}
			/>

			<div className="bk-flow-room__card-description">
				<div className="bk-flow-room__card-description__copy row">
					{ yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) && !_.isEmpty(unrefinedGuestRoom) ?
						<h3>{ unrefinedGuestRoom[0].RoomTypeName }</h3>
					: cards.roomDescription.name ? (
							<h3>{ cards.roomDescription.name }</h3>
					) : (
						null
					)}

					{ yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
						!_.isEmpty(unrefinedGuestRoom) &&
						!_.isEmpty(unrefinedRoomDescription) ?
						<BkFlowRoomCardDescriptionAccordion
							hotelLabels={ hotelLabels }
							roomDescription={ unrefinedRoomDescription[0]['en-US'] }
							roomDescriptionExpanded={ roomDescriptionExpanded }
							roomData={ cards }
							limitChars={ 160 }
							roomDescriptionEvent={ () => roomDescriptionEvent() }
						/>
					: cards.roomDescription &&
						cards.roomDescription.text ?
						<BkFlowRoomCardDescriptionAccordion
							hotelLabels={ hotelLabels }
							roomDescription={ cards.roomDescription.text }
							roomDescriptionExpanded={ roomDescriptionExpanded }
							roomData={ cards }
							limitChars={ 160 }
							roomDescriptionEvent={ () => roomDescriptionEvent() }
						/>
					:
						null
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_FEATURED_ICONS) && <BkFlowFeaturedIcons roomGroup={ roomGroup } roomData={ cards } /> }
				</div>

				<BkFlowRoomCardRateStageCta
					ctaEvent={ () => roomRateStageEvent() }
					currencyCode={ currentCurrencyCode }
					currencySymbol={ currentCurrencySymbol }
					displayedPriceFrequency={displayedPriceFrequency}
					hotelLabels={ hotelLabels }
					hotelPhone={ hotelPhone }
					lowestRate={ lowestRoomRate }
					totalRates={ totalRoomRates }
				/>
			</div>
		</div>
	)
}

export default BkFlowRoomCardMultiStage


// WEBPACK FOOTER //
// ./src/components/room/layouts/BkFlowRoomCardMultiStage.js